import clsx from 'clsx';
import React from 'react';

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4';

const defaultSizes: Record<HeadingLevel, string> = {
    h1: 'text-3xl',
    h2: 'text-2xl',
    h3: 'text-xl',
    h4: 'text-lg',
};

interface HeadingProps {
    as?: HeadingLevel;
    className?: string;
    children: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ as: Tag = 'h2', className, children }) => {
    return (
        <Tag
            className={clsx(
                'font-heading font-bold text-[#505050] dark:text-white',
                defaultSizes[Tag],
                className
            )}
        >
            {children}
        </Tag>
    );
};

export default Heading;
